import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5683%3A144
 *
 * @param {SvgIconProps} props - svg props
 */
export const InboxIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M18 12.9998H17.32L15.32 14.9998H17.23L20 16.9998H4L6.78 14.9998H8.83L6.83 12.9998H6L2 15.9998V19.9998C2 21.0998 2.89 21.9998 3.99 21.9998H20C21.1 21.9998 22 21.1098 22 19.9998V15.9998L18 12.9998ZM17 7.9498L12.05 12.8998L8.51 9.3598L13.46 4.4098L17 7.9498ZM12.76 2.2898L6.39 8.6598C6 9.0498 6 9.6798 6.39 10.0698L11.34 15.0198C11.73 15.4098 12.36 15.4098 12.75 15.0198L19.11 8.6598C19.5 8.2698 19.5 7.6398 19.11 7.2498L14.16 2.2998C13.78 1.8998 13.15 1.8998 12.76 2.2898Z' fill={color}/>
        </SvgIcon>
    )
}

export default InboxIcon
